<div [autofocus]="true" class="modal-body vtr-modal-export-log">
	<h1 id="snapshot-export-log-modal-title" class="title" role="heading">{{ 'snapshot.exportLogModal.exportSnapshot' | translate }}</h1>

	<div [ngSwitch]="errorStatus">
		<p *ngSwitchCase="enumExportLogErrorStatus.SuccessExport" id="snapshot-export-log-modal-description"
			class="description"
			role="text">{{ 'snapshot.exportLogModal.exportSuccessDescription' | translate }} {{ logPath }}</p>

		<p *ngSwitchCase="enumExportLogErrorStatus.AccessDenied" id="snapshot-export-log-modal-description"
			class="description" role="text">{{ 'snapshot.exportLogModal.exportAccessErrorDescription' | translate }}</p>

		<p *ngSwitchCase="enumExportLogErrorStatus.LoadingExport" id="snapshot-export-log-modal-description"
			class="description" role="text">{{ 'snapshot.exportLogModal.exportMayTakeSomeTime' | translate }}</p>

		<p *ngSwitchDefault id="snapshot-export-log-modal-description"
			class="description" role="text">{{ 'snapshot.exportLogModal.exportFailDescription' | translate }}</p>
	</div>

	<div [ngSwitch]="errorStatus" class="row button-row line-separator">

		<div class="col loading" *ngSwitchCase="enumExportLogErrorStatus.LoadingExport">
			<fa-icon role="img"
				[attr.aria-label]="'snapshot.exportLogModal.exportMayTakeSomeTime' | translate"
				placement="auto"
				[spin]="true"
				[icon]="['fal', 'circle-notch']"
				container="body">
			</fa-icon>
		</div>

		<vtr-material-button *ngSwitchCase="enumExportLogErrorStatus.AccessDenied"
			linkId="snapshot-export-log-open-settings-btn"
			[label]="'snapshot.exportLogModal.openSettingsButton' | translate | uppercase"
			(buttonClick)="openWindowsSettings()"
			heightSize="lg">
		</vtr-material-button>

		<vtr-material-button *ngSwitchDefault
			linkId="snapshot-export-log-confirm-btn"
			[label]="'snapshot.ok' | translate | uppercase"
			(buttonClick)="onClosing()"
			heightSize="lg">
		</vtr-material-button>
	</div>

	<div class="btn-modal-close" *ngIf="errorStatus !== enumExportLogErrorStatus.LoadingExport">
		<vtr-ui-close-button linkId="snapshot-export-log-modal-close-btn"
			(clickClose)="onClosing()">
		</vtr-ui-close-button>
	</div>
</div>
